import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { hebrewDays } from '../../constants/hebrew-days';
//import { schedule } from './schedule';
import { Schedule, ScheduleLesson } from '../../interfaces/schedule';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Filter } from '../../interfaces/filter';
import { DataService } from '../../services/data.service';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';
import { environment } from 'src/environments/environment';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { format, addHours } from 'date-fns';
import { LocalizationService } from '../../services/localization.service';
import { ButtonStateService } from '../../services/button-state.service';

declare var gapi: any;
declare const popupsHandler: any;

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss', './schedule.component.en.scss'],
  animations: [
    trigger('openClose', [
      state(
        'opened',
        style({
          width: '*',
        })
      ),
      state(
        'closed',
        style({
          width: 40,
        })
      ),
      transition('opened => closed', [animate('.2s')]),
      transition('closed => opened', [animate('0.2s')]),
    ]),
  ],
})
export class ScheduleComponent implements OnInit {
  @Input() data!: any;
  @Input() days: string[] = LocalizationService.getDaysOfWeek();
  @Input() showDaysName: boolean = true;
  @Input() showFilters: boolean = true;
  @HostBinding('class.mobile-mode') mobileMode: boolean = false;
  @HostListener('window:resize', ['$event']) onResize() {
    this.mobileMode = this.userAgentService.isMobileDevice();
  }

  timeRange: number[] = [];
  schedule: Schedule[] = [{ ranges: [] }];
  activeDay: number = 0;
  isLoading: boolean = false;
  filterItems: Filter[] = [];
  addToCalendarPopupData: any;

  LocalizationService = LocalizationService;

  constructor(
    protected dataService: DataService,
    private userAgentService: UserAgentService,
    private buttonStateService: ButtonStateService
  ) {
    this.mobileMode = this.userAgentService.isMobileDevice();
  }

  ngOnInit(): void {
    //this.data.isNotRegisteredCourses = true; //uncomment for test NotRegisteredCourses component
    this.timeRange = this.data.timeRange;
    this.filterItems = this.data.semesterListFilter;
    this.schedule = this.data.scheduleByDays;
    this.dataService.updateAddToCalendarPopupData$.subscribe((value) => {
      this.addToCalendarPopupData = value;
    });
  }

  @Output() serverErrorAppeared: EventEmitter<void> = new EventEmitter<void>();

  filterPeriodChande(filter: Filter[]) {
    let index = filter.findIndex((c) => c.checked);
    if (index == -1) return;

    this.isLoading = true;
    var url =
      environment.apiUrl +
      '/Portal/StudentCoursesAndScheduleBlockList/SearchSemesterSchedule';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      yearAndSemester: filter[index].value,
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.schedule = responseData.scheduleByDays;
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.isLoading = false;
        this.serverErrorAppeared.emit();
      },
    });
  }

  addToCalendarEvent(type: CalendarItemEnum) {
    if (
      this.isLoading ||
      this.schedule.length == 0 ||
      !this.data.permissionKeys
    )
      return;

    switch (type) {
      case CalendarItemEnum.Gmail:
        this.addToGoogleCalendar();
        break;
      case CalendarItemEnum.Desktop:
        this.generateICSFileAllEventsForDesktopCalender();
        break;
      case CalendarItemEnum.Outlook:
        break;
      case CalendarItemEnum.Yahoo:
        break;
    }
  }

  generateICSFileAllEventsForDesktopCalender() {
    let icsContent = this.generateICSContent();
    let blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', this.data.blockContent.title + '.ics');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  generateICSContent(): string {
    let icsContent = 'BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:BGU\n';
    let lessons = this.extractLessons();

    let id = 0;
    lessons.forEach((lesson) => {
      icsContent += 'BEGIN:VEVENT\n';
      icsContent += 'UID:' + new Date().getTime() + id++ + '\n';
      icsContent += `DTSTART:${lesson.exportDateStart}\n`;
      icsContent += `DTEND:${lesson.exportDateEnd}\n`;
      icsContent += `RRULE:FREQ=WEEKLY;BYDAY=${lesson.exportByDay};UNTIL=${lesson.exportDateUntil}\n`;
      icsContent += 'SUMMARY:' + lesson.name + '\n';
      if (lesson.location) {
        icsContent += 'LOCATION:' + lesson.location + '\n';
      }
      icsContent += 'END:VEVENT\n';
    });

    icsContent += 'END:VCALENDAR';
    return icsContent;
  }

  extractLessons(): ScheduleLesson[] {
    let lessons: ScheduleLesson[] = [];
    this.schedule.forEach((day) => {
      day.ranges.forEach((range) => {
        range.slots.forEach((slot) => {
          slot.lessons.forEach((lesson) => {
            lessons.push(lesson);
          });
        });
      });
    });
    return lessons;
  }
  addToGoogleCalendar() {
    if (!this.data.permissionKeys.google) return;

    // Disable the button
    this.buttonStateService.setButtonDisabled(true);

    const { clientId, apiKey, scopes } = this.data.permissionKeys.google;
    const DISCOVERY_DOCS = [
      'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
    ];

    const showPopup = (
      title: string,
      description: string,
      type: 'success-popup' | 'error-popup',
      iconUrl: string
    ) => {
      popupsHandler.popupMessage(title, description, '', type, iconUrl, [
        {
          label: type === 'success-popup' ? 'OK' : 'Close',
          callback: () => popupsHandler.closePopup(),
        },
      ]);
    };

    gapi.load('client', () => {
      gapi.client.init({
        apiKey,
        discoveryDocs: DISCOVERY_DOCS,
      });
    });

    const tokenClient = (window as any).google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: scopes,
      callback: async (resp: any) => {
        if (resp.error !== undefined) {
          showPopup(
            this.addToCalendarPopupData.addToCalendarFailureTitle,
            this.addToCalendarPopupData.addToCalendarFailureDescription,
            'error-popup',
            this.addToCalendarPopupData.addToCalendarFailureIconUrl
          );
          this.buttonStateService.setButtonDisabled(false); // Re-enable on error
          throw resp;
        }

        try {
          const sendEvents = this.generateEventsJsonForCalendar();

          sendEvents.forEach((event) => {
            const request = gapi.client.calendar.events.insert({
              calendarId: 'primary',
              resource: event,
            });
            request.execute((event: any) => {});
          });

          showPopup(
            this.addToCalendarPopupData.addToCalendarSuccessTitle,
            this.addToCalendarPopupData.addToCalendarSuccessDescription,
            'success-popup',
            this.addToCalendarPopupData.addToCalendarSuccessIconUrl
          );
        } catch (error) {
          console.error(error);
          showPopup(
            this.addToCalendarPopupData.addToCalendarFailureTitle,
            this.addToCalendarPopupData.addToCalendarFailureDescription,
            'error-popup',
            this.addToCalendarPopupData.addToCalendarFailureIconUrl
          );
        }finally{
          this.buttonStateService.setButtonDisabled(false); // Re-enable on error
        }
      },
    });

    setTimeout(() => {
      if (gapi.client.getToken() === null) {
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        tokenClient.requestAccessToken({ prompt: '' });
      }
    }, 1000);
  }

  generateEventsJsonForCalendar(): any[] {
    let events: any[] = [];
    let lessons = this.extractLessons();
    lessons.forEach((lesson) => {
      let nEvent = {
        summary: lesson.name,
        start: {
          dateTime: lesson.exportDateStartIso,
          timeZone: 'Israel',
        },
        end: {
          dateTime: lesson.exportDateEndIso,
          timeZone: 'Israel',
        },
        recurrence: [
          `RRULE:FREQ=WEEKLY;UNTIL=${lesson.exportDateUntil};BYDAY=${lesson.exportByDay}`,
        ],
      };
      if (lesson.location) {
        let nnEvent = {
          ...nEvent,
          location: lesson.location,
        };
        events.push(nnEvent);
      } else {
        events.push(nEvent);
      }
    });
    return events;
  }
}
